import { ENTERPRISE } from 'self-service-api/constants/ProductLevels';
import { BUY_TOUCHLESS, TRIAL } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { useAppSelector } from '../../../reducers';
import { commonAvailableTermsSelector } from '../../../selectors/OfferSelectors';
import { planBuilderCheckoutProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import { crmSuiteProductLevelPreSeatsAndSeatsOnlySelector, skuIdsContainOnlyCrmSuiteSelector } from '../../../selectors/ProductsSelectors';
import { commonPurchaseMotionsSelector, suitePurchaseMotionsMapSelector, talkToSalesTypeSelector } from '../../../selectors/PurchaseMotionSelectors';
export const usePlanBuilderPurchaseMotions = ({
  productConfigurations
}) => {
  const checkoutProductConfigurations = useAppSelector(planBuilderCheckoutProductConfigurationsSelector);
  const suiteProductLevel = useAppSelector(state => crmSuiteProductLevelPreSeatsAndSeatsOnlySelector(state, {
    skuIds: productConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const hasOnlySuiteSkuIds = useAppSelector(state => skuIdsContainOnlyCrmSuiteSelector(state, {
    skuIds: productConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const talkToSalesType = useAppSelector(talkToSalesTypeSelector);
  const purchaseMotions = useAppSelector(state => {
    if (suiteProductLevel && hasOnlySuiteSkuIds && suiteProductLevel !== ENTERPRISE) {
      const suitePurchaseMotionsMap = suitePurchaseMotionsMapSelector(state);
      if (suitePurchaseMotionsMap) {
        return suitePurchaseMotionsMap[suiteProductLevel];
      } else return [];
    }
    const skuIdsToUse = checkoutProductConfigurations.map(({
      skuId
    }) => skuId);
    const commonPurchaseMotions = commonPurchaseMotionsSelector(state, {
      skuIds: skuIdsToUse,
      location: 'CALCULATOR'
    });

    // Some non-exhaustive examples of why we check for common terms:
    // 1. HSFX-eligible products and starter products don't have any common terms,
    // so we cannot send them to checkout touchlessly.
    // 2. Seats customers on MCMP won't have any common terms between Starter and Pro
    // products either.
    const hasCommonTerms = !!commonAvailableTermsSelector(state, {
      skuIds: skuIdsToUse
    }).length;
    if (!hasCommonTerms) {
      const filteredPurchaseMotions = commonPurchaseMotions.filter(purchaseMotion => purchaseMotion !== BUY_TOUCHLESS);
      if (!filteredPurchaseMotions.length) {
        return [talkToSalesType];
      }
      return filteredPurchaseMotions;
    }
    return commonPurchaseMotions;
  });

  // public purchase motions are always 1 button unless trial exist in the array, then show all the buttons
  if (purchaseMotions.includes(TRIAL)) return purchaseMotions;
  if (purchaseMotions.includes(BUY_TOUCHLESS)) return [BUY_TOUCHLESS];
  return [talkToSalesType];
};
export default usePlanBuilderPurchaseMotions;